var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overflow_hidden"},_vm._l((_vm.writeLayouts),function(writeLayout){return _c('gallery-write-link',{key:`gallery${writeLayout}`,attrs:{"galleryData":_vm.galleryData,"write-layout":writeLayout}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }